"use strict";
window.APP = window.APP || {};
APP.Model = Backbone.Model.extend({
  // you can set any defaults you would like here
  defaults: {
    country: "",
    user_email: "",
    user_name: "",
    brand: "",
    text: "",
    gender: "",
    video: "",
    audio: "",
    message: "",
  },
  validate: function (attrs) {
    var errors = {};
    if (!_.isEmpty(errors)) return errors;
  },
});
APP.Collection = Backbone.Collection.extend({
  // Reference to this collection's model.
  localStorage: new Backbone.LocalStorage("CKCollection"),
  model: APP.Model,
});
